
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Aguarde ...</p>
  </ngx-spinner>
  
  <div class="row">
    <div class="col-12">
      <app-card cardTitle="Programa Participantes" blockClass="table-border-style" [options]="false">
        <div class="row">
            <div class="col-md-6 col-sm-6">
              <label for="exampleInputEmail1">Filtro</label>
              <input type="text" class="form-control" [(ngModel)]="query"
                placeholder="Digite seu filtro, sera feito uma busca em todas as colunas" >
            </div>           
       
          </div>
          <br>
        <div class="table-responsive">
          <table class="table table-hover">
            <thead>
              <tr>
                <th>Nome</th>  
                <th></th>
                <th></th>
               
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of arrayTriagem  | fullTextSearch:query">
                <td>{{item.Nome }}</td>          
                <!--<td>{{item.datA_INICIO | date: "dd/MM/yyyy"}}</td>
                <td>{{item.datA_FIM | date: "dd/MM/yyyy"}}</td>-->
                <td>
                  
                  <span *ngIf="item.revisado" class="badge badge-danger">40 %</span>
                  <span *ngIf="!item.revisado" class="badge badge-success">80 %</span>
             
                </td>
                <td>
                  <!--<button *ngIf="item.revisado" type="button" class="btn btn-icon btn-success " ngbTooltip="Copie seu link" (click)="mostrarLink(item)">
                    <i class="feather icon-link"></i>
                  </button> 
                  <button *ngIf="!item.revisado" type="button" class="btn btn-icon btn-warning " ngbTooltip="Triagem não revisada" (click)="mostrarLink(item)">
                    <i class="feather icon-link"></i>
                  </button>   &nbsp;&nbsp;&nbsp; -->
                 
                  <button type="button" class="btn btn-icon btn-success" ngbTooltip="Documentos" (click)="documentos()">
                    <i class="feather icon-upload"></i>
                  </button>  &nbsp;&nbsp;&nbsp;
                  <button type="button" class="btn btn-icon btn-warning" ngbTooltip="Alertas" (click)="alertas()">
                    <i class="feather icon-alert-circle"></i>
                  </button>  &nbsp;&nbsp;&nbsp;
                  <button type="button" class="btn btn-icon btn-info" ngbTooltip="Checlist" >
                    <i class="feather icon-list"></i>
                  </button>  &nbsp;&nbsp;&nbsp;
                  <button type="button" class="btn btn-icon btn-dark" ngbTooltip="Plano de Ação" >
                    <i class="feather icon-edit"></i>
                  </button>  &nbsp;&nbsp;&nbsp;
                  <button type="button" class="btn btn-icon btn-outline-info" ngbTooltip="Cronograma" >
                    <i class="feather icon-align-center"></i>
                  </button>  &nbsp;&nbsp;&nbsp;
                 
                </td>
                
              </tr>
            </tbody>
          </table>
        </div>
      </app-card>
    </div>
  </div>
  